import { BackgroundGarmentMarkersType, GarmentMarkersXMLType } from 'src/types/decorationSpecs';

/**
 * Converts garment markers to/from the PascalCase JSON shape stored in a scene revision's
 * `metadata.markers` field, mirroring `cylinderWarp.ts`'s `metadata.transformations`.
 * Garment markers are scene-maker calibration data (not part of the shared CIM/Dip XML schema),
 * so they ride alongside the XML on the revision record rather than inside it.
 */

export type GarmentMarkersState = {
    Markers: GarmentMarkersXMLType[];
};

export function fromState(markers: BackgroundGarmentMarkersType[]): GarmentMarkersState {
    return {
        Markers: markers.map((marker) => ({
            BackgroundId: marker.id,
            LeftX: marker.leftX,
            RightX: marker.rightX,
            MeasureY: marker.measureY,
            ShoulderTopY: marker.shoulderTopY,
            GarmentBottomY: marker.garmentBottomY,
            CollarBottomY: marker.collarBottomY,
        })),
    };
}

export function toState(markers: GarmentMarkersXMLType[]): BackgroundGarmentMarkersType[] {
    return markers.map((marker) => ({
        id: marker.BackgroundId,
        leftX: marker.LeftX,
        rightX: marker.RightX,
        measureY: marker.MeasureY,
        shoulderTopY: marker.ShoulderTopY,
        garmentBottomY: marker.GarmentBottomY,
        collarBottomY: marker.CollarBottomY,
    }));
}
